import { IQuyDinhSoBuoiTrenTuan } from "../../../model/respone/category/IQuyDinhSoBuoiTrenTuan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQuyDinhSoBuoiTrenTuanActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IQuyDinhSoBuoiTrenTuan[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IQuyDinhSoBuoiTrenTuan | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IQuyDinhSoBuoiTrenTuan,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eQuyDinhSoBuoiTrenTuanActionIds = generateActionTypeIds(
  eQuyDinhSoBuoiTrenTuanActionsObj,
  "QUY_DINH_SO_BUOI_TREN_TUAN"
);

export type IQuyDinhSoBuoiTrenTuanActionTypes = IGenericActionType<
  typeof eQuyDinhSoBuoiTrenTuanActionsObj,
  "QUY_DINH_SO_BUOI_TREN_TUAN"
>;
